import React from "react";
import {
  IonPage,
  IonContent,
  IonHeader,
  // IonTitle,
  // IonToolbar,
  // IonButtons,
  // IonMenuButton,
  IonSpinner,
} from "@ionic/react";

import { AppStateDisplay } from "../../../common";

import styled from "styled-components";

const Spinner = styled(IonSpinner)`
  position: absolute;
  height: 100px;
  width: 100px;
  top: 50%;
  left: 50%;
  margin-left: -50px;
  margin-top: -50px;
  --color: #ffffff;
`;

/**
 * Just an empty splash screen with an IonLoading or IonError
 */
const AppInitializationPage = (props) => {
  return (
    <IonPage>
      <IonHeader>
        {/* <IonToolbar color="primary">
          <IonTitle>{process.env.REACT_APP_NAME}</IonTitle>
          <IonButtons slot="start">
            <IonMenuButton autoHide={false}></IonMenuButton>
          </IonButtons>
        </IonToolbar> */}
      </IonHeader>
      <IonContent color="primary" fullscreen>
        <AppStateDisplay parsedQuery={props.parsedQuery}>
          <Spinner name="lines" />
        </AppStateDisplay>
      </IonContent>
    </IonPage>
  );
};

export default AppInitializationPage;
